import { HttpErrorResponse } from '@angular/common/http';
import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Subject, switchMap } from 'rxjs';
import { BookshelfAPIService } from 'shared/services';
import { ToastService, TypedDialog } from 'shared/ui';

@Component({
  selector: 'lib-delete-bookshelf',
  templateUrl: './delete-bookshelf.component.html',
  styleUrl: './delete-bookshelf.component.scss',
})
export class DeleteBookshelfComponent
  extends TypedDialog<
    { bookshelf_id: string },
    { canceled: 'success' | 'fail' }
  >
  implements OnInit, OnDestroy
{
  private _deleteBookshelfSubject = new Subject<void>();
  private _submitLoadingIndicatorTimer: ReturnType<typeof setTimeout> | null =
    null;

  public _isSaving = false;
  public _showSubmitLoadingIndicator = false;

  constructor(
    private _bookshelfAPIService: BookshelfAPIService,
    private _toastService: ToastService,
    private _ngZone: NgZone
  ) {
    super();
  }

  ngOnInit(): void {
    this._deleteBookshelfSubject
      .pipe(
        switchMap(() => {
          return this._bookshelfAPIService.deleteBookshelf(
            this._data.bookshelf_id
          );
        })
      )
      .subscribe({
        next: () => {
          this._clearSubmitLoadingIndicatorTimer();
          this._dialogRef.close({ canceled: 'success' });
        },
        error: (error: HttpErrorResponse) => {
          this._clearSubmitLoadingIndicatorTimer();
          this._isSaving = false;
          this._showSubmitLoadingIndicator = false;
          this._toastService.open(
            `오류가 발생했습니다. 잠시 후 다시 시도해주세요. (${error.status})`
          );
        },
      });
  }

  ngOnDestroy(): void {
    this._clearSubmitLoadingIndicatorTimer();
    this._deleteBookshelfSubject.complete();
  }

  public _onClickDelete(): void {
    if (this._isSaving) {
      return;
    }

    this._clearSubmitLoadingIndicatorTimer();
    this._showSubmitLoadingIndicator = false;
    this._isSaving = true;
    this._submitLoadingIndicatorTimer = setTimeout(() => {
      this._submitLoadingIndicatorTimer = null;
      this._ngZone.run(() => {
        if (this._isSaving) {
          this._showSubmitLoadingIndicator = true;
        }
      });
    }, 1000);

    this._deleteBookshelfSubject.next();
  }

  private _clearSubmitLoadingIndicatorTimer(): void {
    if (this._submitLoadingIndicatorTimer !== null) {
      clearTimeout(this._submitLoadingIndicatorTimer);
      this._submitLoadingIndicatorTimer = null;
    }
  }
}
